module.exports = __webpack_public_path__ + "img/very-popular-topic.93d86fb4.png";